import * as moment from "moment";
import english from "react-date-object/locales/gregorian_en";

export const getDateFormat = (date, currentFormat = null, time = null) => {
  if (!date) {
    return "";
  }

  const languageList = JSON.parse(localStorage.getItem("language_list")) || [];
  const lang = localStorage.getItem("locale");
  const selectedLanguage = languageList.find((item) => item.lang === lang);
  let format = selectedLanguage?.dateFormat || "yyyy-MM-dd";
  format = format
    .replace(/yyyy/g, "YYYY")
    .replace(/yy/g, "YY")
    .replace(/dd/g, "DD");

  if (time) {
    format += ` ${time}`;
  }

  return currentFormat
    ? moment(date, currentFormat).format(format)
    : moment(date).format(format);
};

export const getDatePickerFormat = () => {
  const languageList = JSON.parse(localStorage.getItem("language_list")) || [];
  const lang = localStorage.getItem("locale");
  const selectedLanguage = languageList.find((item) => item.lang === lang);
  return (selectedLanguage?.dateFormat || "yyyy-MM-dd")
    .replace(/yyyy/g, "YYYY")
    .replace(/yy/g, "YY")
    .replace(/dd/g, "DD");
};

const getMonthNames = (locale) =>
  Array.from({ length: 12 }, (_, i) => {
    const date = new Date(2024, i, 1);

    return [
      new Intl.DateTimeFormat(locale, { month: "long" }).format(date),
      new Intl.DateTimeFormat(locale, { month: "short" })
        .format(date)
        .replace(/\./g, ""),
    ];
  });

const getWeekDays = (locale) =>
  Array.from({ length: 7 }, (_, i) => {
    const date = new Date(2024, 0, 7 + i);

    return [
      new Intl.DateTimeFormat(locale, { weekday: "long" }).format(date),
      new Intl.DateTimeFormat(locale, { weekday: "short" })
        .format(date)
        .replace(/\./g, ""),
    ];
  });
const createLocale = (locale, name) => ({
  ...english,
  name,
  months: getMonthNames(locale),
  weekDays: getWeekDays(locale),
});

const locales = {
  en: english, // English
  fr: createLocale("fr-FR", "gregorian_fr"), // French
  pl: createLocale("pl-PL", "gregorian_pl"), // Polish
  bl: createLocale("nl-BE", "gregorian_bl"), // Belgium (Dutch)
  nt: createLocale("nl-NL", "gregorian_nt"), // Netherlands
  de: createLocale("de-DE", "gregorian_de"), // Germany
  sp: createLocale("es-ES", "gregorian_sp"), // Spain
  ch: createLocale("de-CH", "gregorian_ch"), // Switzerland (German)
  it: createLocale("it-IT", "gregorian_it"), // Italy
  sv: createLocale("sv-SE", "gregorian_sv"), // Swedish
};

export const getCalendarLocale = () => {
  const lang = localStorage.getItem("locale") || "en";
  return locales[lang] || english;
};
